"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import { useContactPageData } from "../../hooks/useContactPageData";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

const ContactInfo = () => {
  const t = useTranslations();
  const { contacts, isLoading } = useContactPageData();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  if (!contacts || isLoading) return null;

  return (
    <div className={S.wrapper}>
      <div className={S.titleWrapper}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h2 className={S.title}>{t("contacts")}</h2>
      </div>

      <div className={S.block}>
        <h3 className={S.subtitle}>{t("hotline")}</h3>
        {contacts.hotline?.map(item => (
          <div className={S.textWrapper} key={item.title}>
            <p className={S.city}>{item.title}</p>
            <a className={S.phone} href={`tel:${item.phone}`}>
              {item.phone}
            </a>
          </div>
        ))}
      </div>
      <div className={S.block}>
        <h3 className={S.subtitle}>{t("brandCenter")}</h3>
        {contacts.brand_center?.map(item => (
          <div className={S.textWrapper} key={item.city}>
            <p className={S.city}>{item.city}</p> <p className={S.address}>{item.address}</p>
            <a className={S.phone} href={`tel:${item.phone}`}>
              {item.phone}
            </a>
            <p className={S.additional}>{item.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
